import * as React from "react";

import I18n, { TranslationsObjectKeys } from "lib/I18n";
import { Graph } from "../Graph";
import { QueryLog } from "../../store";

interface PieProps {
  logs: QueryLog[];
  userSelected: (userId: string, userName: string) => void;
}

export function Pie(props: PieProps) {
  const { logs, userSelected } = props;

  const sliceClicked = (e: unknown) => {
    if (typeof e != "object" || !e) {
      return;
    }
    if (!("dataItem" in e)) {
      return;
    }
    if (typeof e.dataItem != "object" || !e.dataItem) {
      return;
    }
    if (!("dataContext" in e.dataItem)) {
      return;
    }
    if (typeof e.dataItem.dataContext != "object" || !e.dataItem.dataContext) {
      return;
    }
    if (!("userId" in e.dataItem.dataContext)) {
      return;
    }
    if (typeof e.dataItem.dataContext.userId != "string") {
      return;
    }
    if (!("userName" in e.dataItem.dataContext)) {
      return;
    }
    if (typeof e.dataItem.dataContext.userName != "string") {
      return;
    }
    userSelected(
      e.dataItem.dataContext.userId,
      e.dataItem.dataContext.userName,
    );
  };

  const prepareChartData = () => {
    const chartData: {
      [index: string]: {
        userId: string;
        userName: string;
        sector: string;
        cost: number;
      };
    } = {};
    logs.forEach((log) => {
      let userId = log.user_id;
      if (userId == null) {
        userId = "";
      }
      if (!chartData[userId]) {
        const userName =
          log.user_name != null
            ? log.user_name
            : I18n.t(
                `bigquery_history_viewer.context.${log.context}` as TranslationsObjectKeys,
              );
        chartData[userId] = {
          userId,
          userName,
          sector: userName,
          cost: 0,
        };
      }
      chartData[userId].cost += log.cost;
    });
    return Object.keys(chartData)
      .map((key) => chartData[key])
      .sort((c1, c2) => {
        return c2.cost - c1.cost;
      });
  };

  const prepareConfig = () => {
    const chartData = prepareChartData();
    return {
      pathToImages: "/assets/amcharts/",
      type: "pie",
      theme: "light",
      valueField: "cost",
      titleField: "sector",
      startDuration: 0,
      innerRadius: 70,
      pullOutRadius: 20,
      marginTop: 30,
      allLabels: [
        {
          y: "50%",
          align: "center",
          size: 25,
          bold: true,
          text: `$${chartData
            .map((c) => c.cost)
            .reduce((p, c) => p + c, 0)
            .toPrecision(3)}`,
          color: "#555",
        },
        {
          y: "44%",
          align: "center",
          size: 15,
          text: I18n.t(`bigquery_history_viewer.label.sum`),
          color: "#555",
        },
      ],
      dataProvider: chartData,
      listeners: [
        {
          event: "clickSlice",
          method: sliceClicked,
        },
      ],
    };
  };

  return (
    <div>
      <Graph id="history-viewer-pie" config={prepareConfig()} />
    </div>
  );
}
